import Vue from 'vue'
import VueRouter from 'vue-router'
import privateHome from '@/views/_Private.vue'
import { authClientInstance } from '@/auth/AuthClient'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'login',
    meta: { type: 'public' },
    component: () => import('@/views/Home.vue')
  },
  {
    path: '/no-member',
    name: 'no-member',
    component: () => import('@/views/NoMember.vue')
  },
  {
    path: '/rgcc',
    component: privateHome,
    children: [
      {
        path: '',
        name: 'options',
        meta: { title: '¿Qué desea hacer?' },
        component: () => import('@/views/Options.vue')
      },
      {
        path: 'pase-cursillos',
        name: 'courses-pass',
        meta: { title: 'Pase cursillos' },
        component: () => import('@/views/CoursePassesList.vue')
      },
      {
        path: 'pase-deportistas',
        name: 'sports-pass',
        meta: { title: 'Pase deportistas' },
        component: () => import('@/views/SportPassesList.vue')
      },
      {
        path: 'pase-auxiliar',
        name: 'auxiliar-pass',
        meta: { title: 'Pase auxiliar' },
        component: () => import('@/views/AuxiliarPassesList.vue')
      },
      {
        path: 'renovacion-tarjeta-socio',
        name: 'membership-card-renewal',
        meta: { title: 'Duplicado de carné social' },
        component: () => import('@/views/MembershipCardRenewal.vue')
      },
      {
        path: 'acceso-biometrico',
        name: 'biometric-config',
        meta: { title: 'Alta de acceso biométrico' },
        component: () => import('@/views/Biometric.vue')
      }
    ]
  },
  {
    path: '*',
    meta: { type: 'both' },
    component: () => import('@/views/PageNotFound.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(async (to, from, next) => {
  try {
    if (to.path === '/auth') {
      await authClientInstance.loginCallback()
    }

    if (to.path === '/logout') {
      await authClientInstance.logoutCallback()
      return next('/')
    }

    const user = await authClientInstance.getUser()
    store.commit('auth/setAuthUserInfo', user)

    const type = (to.meta && to.meta.type) ? to.meta.type : 'private'
    if (type === 'private') {
      let me = store.getters['auth/user']
      if (!me) {
        try {
          await store.dispatch('auth/downloadMe')
          me = store.getters['auth/user']
        } catch (error) {
          await store.dispatch('auth/logout')
        }
      }
      if (me && me.cuota === 'no socio' && to.path !== '/no-member') {
        return next('/no-member')
      }
      if (user) {
        return next()
      }
      return next({ name: process.env.VUE_APP_REDIRECT_FAILED_AUTHENTICATION })
    }

    if (type === 'public') {
      if (user) {
        return next({ name: process.env.VUE_APP_REDIRECT_LOGGED_IN })
      }
    }

    return next()
  } catch (error) {
    return next('/')
  }
})

export default router
